import { render } from "./Skiing.vue?vue&type=template&id=9668d120&scoped=true&bindings={\"images\":\"data\"}"
import script from "./Skiing.vue?vue&type=script&lang=js"
export * from "./Skiing.vue?vue&type=script&lang=js"

import "./Skiing.vue?vue&type=style&index=0&id=9668d120&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9668d120"

export default script